


































import { Component, Vue, Prop } from "vue-property-decorator";
import Navbar from "../components/Navbar.vue";
import SinglePeople from "../components/SinglePeople.vue";
import { FlatProfile } from "../store/store.types";
import { Action } from "vuex-class";
import { namespaced, NS_PUBLIC } from "../store/namespace";
import { FETCH_LEADERBOARD } from "../store/actions.names";
@Component({
  name: "Leaderboard",
  components: {
    Navbar,
    SinglePeople
  }
})
export default class LeaderBoard extends Vue {
  leaderData: FlatProfile[] = [];
  @Action(namespaced(NS_PUBLIC, FETCH_LEADERBOARD)) fetchLeaderBoard: any;

  mounted() {
    this.fetchLeaderBoard(20).then(data => {
      this.leaderData = data;
    });
  }
}
